import React, { useState } from 'react';
import { Header } from './components/Header';
import { Dashboard } from './components/Dashboard';
import { TestDetails } from './components/TestDetails';
import { MetricsOverview } from './components/MetricsOverview';
import { StatisticalMatrix } from './components/StatisticalMatrix';
import { AssetAnalysis } from './components/AssetAnalysis';
import { KeyInsights } from './components/KeyInsights';
export const App: React.FC = () => {
  const [timeRange, setTimeRange] = useState('30d');
  return <div className="min-h-screen bg-[#003B64] flex flex-col" data-id="element-0" data-mp="2mmlvz9b4ad6w">
      <Header timeRange={timeRange} setTimeRange={setTimeRange} data-id="element-1" data-mp="31aqd48uiugnk" />
      <main className="w-full max-w-[1440px] mx-auto px-6 lg:px-8 py-8 flex-grow" data-id="element-2" data-mp="31c1hoavsjsfq">
        <Dashboard timeRange={timeRange} data-id="element-3" data-mp="2wj8e3qc26q58" />
      </main>
      <footer className="bg-black text-white py-8 mt-12 border-t border-gray-800" data-id="element-4" data-mp="28u5yeo0zj7dd">
        <div className="w-full max-w-[1440px] mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-5" data-mp="28s2ynca15zvg">
          <p className="text-sm font-medium" data-id="element-6" data-mp="3ikh7o8icgqyg">
            Prepared for Lagardère Travel Retail
          </p>
          <p className="text-sm text-[#707070] mt-4 md:mt-0" data-id="element-7" data-mp="3mkre1ma1tjdu">
            Lagardère Travel Retail · Attention Testing
          </p>
        </div>
      </footer>
    </div>;
};